import * as React from 'react';
import { MutationFunc } from 'react-apollo';
import { RouteComponentProps, Redirect } from 'react-router';

import { Loader } from '../../modules/modules';
import AuthService from '../../services/AuthService';
import FlashStore from '../../services/FlashStore';
import CountryService from '../../services/CountryService';
import CartService from '../../services/CartService';

import Home from '../Home';

interface IForceLoginProps extends RouteComponentProps<{ token: string }> {
  acceptForceLogin: MutationFunc;
}

interface IForceLoginState {
  redirect: boolean;
}

class ForceLogin extends React.Component<IForceLoginProps, IForceLoginState> {

  constructor(props: IForceLoginProps) {
    super(props);

    this.state = {
      redirect: false,
    };
  }

  public async componentDidMount() {
    if (this.props.match && this.props.match.params && this.props.match.params.token) {
      try {
        const result = await this.props.acceptForceLogin({
          variables: {
            token: this.props.match.params.token,
          },
        });

        if (result && result.data && result.data.acceptForceLogin) {
          // jsem přihlášen
          CartService.GetInstance().removeEverything();
          AuthService.GetInstance().removeToken();
          AuthService.GetInstance().setLogin(result.data.acceptForceLogin);
          FlashStore.GetInstance().showMessage('You are logged in', 'success');

          // přesměrování na zemi zákazníka
          const { country } = result.data.acceptForceLogin;
          if (country) {
            CountryService.GetInstance().setCountry(country, true);
          }
        }

      } catch (err) {
        console.error(err);

      }

      // redirect na hp
      this.setState({
        redirect: true,
      });
    }
  }

  public render() {
    const { countryCode } = CountryService.GetInstance();

    if (this.state.redirect) {
      (window as any).location = `/${countryCode}`;
    }

    return (
      <React.Fragment>
        <Home />
        <Loader />
      </React.Fragment>
    );
  }
}

export default ForceLogin;



// WEBPACK FOOTER //
// ./src/pages/ForceLogin/ForceLogin.tsx